<style>
.center {
  margin: 18px 0 0 20px;
}
</style>

<template>
  <div class="app-container">
    <ut-form inline class="center">
      <ut-form-item label="应用ID" index="git">
        <ut-input v-model="appId"></ut-input>
      </ut-form-item>
      <ut-form-item label="应用名称" index="git">
        <ut-input v-model="appName"></ut-input>
      </ut-form-item>
      <ut-form-item label="系统级别">
        <ut-select v-model="selected1" clearable>
          <ut-option v-for="item in levelOptions" :value="item.value" :key="item.value" :label="item.label"></ut-option>
        </ut-select>
      </ut-form-item>
      <ut-form-item>
        <ut-button type="primary" @click="search">查询</ut-button>
      </ut-form-item>
      <ut-form-item>
        <ut-button type="primary" @click="goAdd">添加</ut-button>
      </ut-form-item>
    </ut-form>

    <ut-table :source="dataSource" border>
      <ut-table-column title="应用ID" key="appId" index="appId" />
      <ut-table-column title="应用名称" key="appName" index="appName" />
      <ut-table-column
                       title="系统级别"
                       key="level"
                       index="level"
                       :formatter="formatLevel"
                       inline-template>
        <ut-tag :type="formatLevel(row.level)">{{ row.level}} 级系统</ut-tag>
      </ut-table-column>
      <ut-table-column title="负责人" key="owners" index="owners" inline-template>
        <div>
          <ut-tag
                  :style="{marginRight: '8px'}"
                  v-for="owner in row.owners"
                  :key="owner.id">{{ owner.name }}</ut-tag>
        </div>
      </ut-table-column>
      <ut-table-column title="应用描述" key="description" index="description" />
      <ut-table-column title="操作" inline-template>
        <div>
          <ut-button type="info" size="small" @click.native="update($index,row)" :style="{marginLeft:'5px'}">修改</ut-button>
          <ut-popconfirm @confirm="deleteRow($index,row)" title="你确定要删除本行么？">
            <ut-button type="danger" size="small" :style="{marginLeft:'5px'}">删除</ut-button>
          </ut-popconfirm>
        </div>
      </ut-table-column>
    </ut-table>
    <ut-pagination
                   :style="{ marginLeft: '50%', transform: 'translateX(-50%)', marginTop: '20px' }"
                   :total="pageInfo.totalCount"
                   :current="pageNo"
                   @change="changePager"
                   :page-size="20"></ut-pagination>
  </div>
</template>

<script lang="babel">
export default {
  data () {
    return {
      levelOptions: [
        // {
        //   value: '0',
        //   label: '0级别系统'
        // },
        {
          value: '1',
          label: '1级别系统'
        },
        {
          value: '2',
          label: '2级别系统'
        },
        {
          value: '3',
          label: '3级别系统'
        }
      ],
      selected1: '',
      appId: '',
      appName: '',
      inline: {
        range: [],
        type: ''
      },
      pageInfo: {
        totalCount: 0
      },
      pageNo: 1,
      columns: [
        {
          title: '应用ID',
          index: 'appId',
          key: 'appId'
        },
        {
          title: '应用名称',
          index: 'appName',
          key: 'appName'
        },
        {
          title: '系统级别',
          index: 'level',
          key: 'level'
        },
        {
          title: '负责人',
          index: 'owners',
          key: 'owners'
        },
        {
          title: '应用描述',
          index: 'description',
          key: 'description'
        },
        {
          title: '操作',
          index: 'address',
          key: 'address'
        }
      ],
      dataSource: []
    }
  },
  methods: {
    goAdd () {
      this.$router.push({ path: '/apps/add' })
    },
    update (idx, row) {
      var json = {
        path: '/apps/edit',
        query: {
          id: row.appId
        }
      }
      this.$router.push(json)
    },
    deleteRow (idx, row) {
      console.log('delete this.dataSource.length idx [' + this.dataSource.length + '] row [' + idx + ']')
      if (this.dataSource.length == 1 && this.pageNo != undefined) {
        this.pageNo = 0
        this.pageInfo.totalCount = 1
      }
      this.$http({
        method: 'post',
        url: 'apps/' + row.appId + '/remove.htm'
      })
        .then(response => {
          // 这里使用了ES6的语法
          console.log(response) // 请求成功返回的数据
          var sendData = {}

          if (this.selected1 != undefined && this.selected1 != '') {
            sendData.level = this.selected1
          }
          if (this.appId != '') {
            sendData.appId = this.appId
          }
          if (this.appName != '') {
            sendData.appName = this.appName
          }
          if (this.pageNo == undefined) {
            sendData.pageNo = 0
          } else {
            sendData.pageNo = this.pageNo
          }

          console.log(sendData)
          var sendJson = JSON.stringify(sendData)

          this.$http({
            method: 'post',
            url: 'apps/query.htm',
            data: sendJson
          })
            .then(response => {
              // 这里使用了ES6的语法
              console.log(response) // 请求成功返回的数据
              this.dataSource = response.data.dataList
            })
            .catch(error => {
              console.log(error) // 请求失败返回的数据
            })
        })
        .catch(error => {
          console.log(error) // 请求失败返回的数据
        })
    },
    formatLevel (level) {
      switch (level) {
        case 0: {
          return '2'
        }
        case 1: {
          return 'primary'
        }
        case 2: {
          return 'success'
        }
        case 3: {
          return 'warning'
        }
        case 4: {
          return 'danger'
        }
      }
    },
    changePager (page) {
      var sendData = {}
      if (page == 0) {
        return false
      }
      if (this.selected1 != undefined && this.selected1 != '') {
        sendData.level = this.selected1
      }
      if (this.appId != '') {
        sendData.appId = this.appId
      }
      if (this.appName != '') {
        sendData.appName = this.appName
      }
      sendData.pageNo = page

      console.log(sendData)
      var sendJson = JSON.stringify(sendData)

      this.$http({
        method: 'post',
        url: 'apps/query.htm',
        data: sendJson
      })
        .then(response => {
          this.$message.info(`当前切换到第${page}页`)
          // 这里使用了ES6的语法
          console.log(response) // 请求成功返回的数据
          this.pageNo = page
          this.dataSource = response.data.dataList
        })
        .catch(error => {
          console.log(error) // 请求失败返回的数据
        })
    },
    search () {
      var sendData = {}

      if (this.selected1 != undefined && this.selected1 != '') {
        sendData.level = this.selected1
      }
      if (this.appId != '') {
        sendData.appId = this.appId
      }
      if (this.appName != '') {
        sendData.appName = this.appName
      }
      if (this.pageNo == undefined) {
        sendData.pageNo = 0
      } else {
        sendData.pageNo = 1
      }
      console.log(sendData)
      var sendJson = JSON.stringify(sendData)
      console.log(sendJson)
      this.$http({
        method: 'post',
        url: 'apps/query.htm',
        data: sendJson
      })
        .then(response => {
        // 这里使用了ES6的语法
          console.log(response) // 请求成功返回的数据
          this.dataSource = response.data.dataList
          this.pageInfo.totalCount = response.data.totalCount
          this.pageNo = response.data.totalPageCount > 0 ? 1 : 0
          this.$message.info(`当前切换到第${this.pageNo}页`)
        })
        .catch(error => {
          console.log(error) // 请求失败返回的数据
        })
    }
  },
  created () {
    this.$http({
      method: 'post',
      url: 'apps/query.htm',
      data: '{}'
    })
      .then(response => {
        // if (response === undefined) {
        //   console.log('没有返回数据')
        //   this.$message.info(`系统异常跳回登录`)
        //   this.$router.push({ path: '/login' })
        // }
        this.dataSource = response.data.dataList
        this.pageInfo.totalCount = response.data.totalCount
      })
      .catch(error => {
        console.log(error) // 请求失败返回的数据
      })
  },
  filters: {
    setStr (s) {
      return s.owners.map(item => item.name).join(',')
    }
  }
}
</script>
